import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app-config.loader';
import { Classifica } from '../shared/models/classifica.model';
import { AnagraficaBaseService } from './anagrafica-base.service';

@Injectable({
  providedIn: 'root'
})
export class AnagraficaClassificheService extends AnagraficaBaseService<Classifica> {
  constructor(appConfig: AppConfig, http: HttpClient) {
    super(http, `${appConfig.settings.apiRoot}/AnagraficaClassifiche`);
  }

  get idProperty(): string {
    return 'classificaId';
  }

  get nameProperty(): string {
    return 'nomeClassifica';
  }
}
